import React from "react";
import { motion } from "framer-motion";
import { Eye, Compass, ShieldCheck } from "lucide-react";

const blocks = [
  { icon: Eye, title: "Our Vision", body: "To become a globally recognized AI-powered digital company that empowers businesses through innovation, intelligent marketing, and world-class technology solutions." },
  { icon: Compass, title: "Our Mission", body: "Deliver measurable business growth through AI, branding, web development, automation and performance marketing — while building long-term partnerships with our clients." },
  { icon: ShieldCheck, title: "Our Promise", body: "Every strategy we build is designed to increase visibility, generate quality leads, maximize ROI and create sustainable growth for ambitious businesses." },
];

export default function Vision() {
  return (
    <section className="relative py-32 bg-[#070707] border-y border-white/5 overflow-hidden">
      <div className="aurora bg-[#10B981] w-[560px] h-[560px] top-20 left-1/2 -translate-x-1/2" style={{opacity:0.16}} />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="max-w-4xl">
          <span className="eyebrow-emerald">Our Vision</span>
          <h2 className="mt-6 text-4xl md:text-6xl font-semibold leading-tight">
            Shaping the future of <span className="text-gold-gradient">AI-driven</span> <span className="text-emerald-gradient">digital excellence.</span>
          </h2>
          <p className="mt-6 text-white/60 text-lg max-w-2xl leading-relaxed">
            At SYR Mediaworks we combine creativity, artificial intelligence, performance
            marketing and cutting-edge technology to build brands that inspire, scale and
            lead the digital future.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {blocks.map((b, i) => (
            <motion.div
              key={b.title}
              initial={{opacity:0, y:24}}
              whileInView={{opacity:1, y:0}}
              viewport={{once:true}}
              transition={{duration:0.6, delay: i*0.1, ease:[0.16,1,0.3,1]}}
              className="relative rounded-3xl p-8 glass card-lift overflow-hidden"
            >
              <div className="absolute inset-0 opacity-40 pointer-events-none" style={{background:"radial-gradient(circle at 20% 0%, rgba(201,162,39,0.14), transparent 50%)"}} />
              <div className="relative">
                <div className="w-12 h-12 rounded-xl grid place-items-center border border-[#C9A227]/30 bg-[#C9A227]/5">
                  <b.icon size={20} className="text-[#F4D983]" />
                </div>
                <h3 className="mt-6 text-2xl font-semibold">{b.title}</h3>
                <p className="mt-4 text-white/65 leading-relaxed">{b.body}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Values banner */}
        <div className="mt-16 relative overflow-hidden rounded-3xl border border-[#C9A227]/25 glass-gold p-10 md:p-14">
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#047857]/25 blur-3xl" />
          <div className="grid md:grid-cols-4 gap-8 items-center relative">
            {[
              ["Data Driven","Smart Decisions"],
              ["Transparent","Ethical & Compliant"],
              ["Result Oriented","Performance First"],
              ["Nation First","Building Digital India"],
            ].map(([t,s])=>(
              <div key={t}>
                <div className="text-xs uppercase tracking-[0.28em] text-[#F4D983]">{t}</div>
                <div className="mt-2 text-white/75">{s}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
